import { useUnit } from 'effector-react';

import { userService } from '@services/user';
import { parseInitials } from '@utilities/helpers/parsers';

import styles from './AccountMenu.module.scss';

export const AccountMenu = () => {
	const user = useUnit(userService.$user);
	return user?.name ? (
		<button className={styles.accountMenu}>
			<span className={styles.initials}>{parseInitials(user.name)}</span>
			<span className={styles.name}>{user.name}</span>
		</button>
	) : null;
};
